<freud-loader
	class="loading zk-mt-15"
	*ngIf="loading"
	size="sm"
	[bgColor]="false"
></freud-loader>

<div class="empty" *ngIf="appointments.list.length === 0 && loading === false">
	<p *ngIf="filter === null">{{ 'CONTACT.INFOS.NO_SESSIONS' | translate }}</p>
	<p *ngIf="filter">{{ 'CONTACT.INFOS.NO_REGISTERED_PROMPTUARIES' | translate }}</p>
</div>


<div class="appointment" *ngFor="let item of appointments.list; index as index">
	<div class="v-line"></div>

	<div class="timeline-square">
		<span class="freud-icon freud-icon-md freud-icon-calendar-event"></span>
	</div>

	<div class="card">
		<div class="date">
			{{ item.day | date: 'd MMM yy' }}
		</div>

		<div class="wrap-group">
			<div class="appointment-type-badge">
				<appointment-type-badge [subscriptionType]="item?.compensationInfo?.subscription?.type || null" [iconOnly]="true"></appointment-type-badge>
			</div>

			<div class="hour">
				<span class="freud-icon freud-icon-xs freud-icon-clock"></span>
				<div class="value">{{ item.day | date: "H'h'mm" }}</div>
			</div>

			<div class="price" *ngIf="item.priceFinalCompensation > 0">
				<span class="freud-icon freud-icon-xs freud-icon-report-money"></span>
				<div class="value">{{ item.priceToShow }}</div>
			</div>

			<div
				class="register-by-professional"
				*ngIf="professionalId && item.professionalId !== professionalId"
			>
				<span class="freud-icon freud-icon-xs freud-icon-user-circle"></span>
				<div class="value">
					{{ item.formattedProfessionalName  }}
				</div>
			</div>
		</div>

		<div class="wrap-cta">
			<label
				class="not-happened"
				*ngIf="!item.hasPromptuary && !item.sessionInFuture"
				[ngClass]="{ disabled: item.notEditable }"
				pTooltip="{{
					item.notEditable ? ('CONTACT.INFOS.NOT_EDITABLE' | translate) : ''
				}}"
				tooltipPosition="top"
			>
				<freud-loader
					*ngIf="item.loading"
					class="loader"
					size="sm"
					[bgColor]="false"
				></freud-loader>

				<input
					[id]="formatNoShowId(index)"
					*ngIf="!item.loading"
					type="checkbox"
					(change)="setAppointmentAsNoshow($event.target.checked, index)"
					[checked]="item.noShow"
					[disabled]="item.notEditable"
				/>
				{{ 'CONTACT.NOSHOW_TIMELINE' | translate }}
			</label>

			<div
				class="create"
				*ngIf="!item.noShow && !item.hasPromptuary"
				pTooltip="{{
					item.sessionInFuture
						? ('CONTACT.INFOS.SESSION_IN_FUTURE' | translate)
						: ''
				}}"
				tooltipPosition="top"
			>
				<freud-button
					(click)="
						!item.sessionInFuture && openRegisterPromptuarySidebar(item, 'BtnRegister')
					"
					[disabled]="item.sessionInFuture"
				>
					{{ 'CONTACT.PROMPTUARY' | translate }}
				</freud-button>
			</div>

			<div
				class="create"
				*ngIf="validateShowToScheduleNoShowButton(item)"
				pTooltip="{{
					validateIfRepositionInviteAlreadySent(item)
						? ('CONTACT.INFOS.REPOSITION_SENT' | translate)
						: ''
				}}"
				tooltipPosition="top"
			>
				<freud-button
					(click)="
						scheduleNowShowAppointment(item)
					"
					color="secondary"
					[disabled]="item.sessionInFuture || validateIfRepositionInviteAlreadySent(item) || repositionInviteSent"
				>
					{{ 'CONTACT.TO_SCHEDULE_NO_SHOW_BUTTON' | translate }}
				</freud-button>
			</div>

			<div
				class="view"
				*ngIf="item.hasPromptuary"
				pTooltip="{{ 'CONTACT.INFOS.VIEW_PROMPTUARY' | translate }}"
				(click)="redirectToRegisteredPromptuary(item)"
			>
				<span class="freud-icon freud-icon-md freud-icon-license"></span>
			</div>
		</div>
	</div>
</div>

<freud-button
	*ngIf="
		appointments.total && pageSize.actual < appointments.total && !loadingMore
	"
	(click)="loadMore()"
>
	{{ 'CONTACT.LOAD_MORE' | translate }}
</freud-button>

<freud-loader
	class="loading end-page"
	*ngIf="loadingMore"
	size="sm"
	[bgColor]="false"
></freud-loader>
<appointment-sidebar></appointment-sidebar>

<freud-dialog class="noshow-modal" [visible]="noShowClickIndex >= 0" (visibleChange)="!$event && closeNoShowModal()"
	[modal]="true" [draggable]="false" [header]="'SCHEDULE.NOSHOW_CONFIRM_TITLE' | translate">
	<span class="noshow-modal__description">{{
		'SCHEDULE.NOSHOW_CONFIRM_DESC' | translate
		}}</span>
	<ng-container freudTemplatefooter>
		<freud-button [loading]="loadingConfirmNoShow" (click)="setAppointmentAsNoshow(true, noShowClickIndex)">{{
			'SCHEDULE.NOSHOW_CONFIRM_BUTTON' | translate
			}}</freud-button>
		<freud-button color="ghost" (click)="closeNoShowModal()"> {{ 'SCHEDULE.NOSHOW_CANCEL_BUTTON' | translate
			}}</freud-button>
		</ng-container>
</freud-dialog>